import {
    ResearchTeamMemberAccessStatusEnum,
    ResearchTeamMemberAccountStatusEnum,
    VmAdminApprovalStatusEnum
} from '@vivli/features/data-requests/infrastructure/enum';

const VmAdminApprovalLabels = {
    [VmAdminApprovalStatusEnum.NeedsApproval]: 'Access to data pending',
    [VmAdminApprovalStatusEnum.NotApplicable]: 'Access to data not applicable',
    [VmAdminApprovalStatusEnum.Approved]: 'Access to data granted',
    [VmAdminApprovalStatusEnum.Disapproved]: 'Access to data denied',
    [VmAdminApprovalStatusEnum.Automatic]: null
};

const menuVMAdminApprovalLabels = {
    [VmAdminApprovalStatusEnum.NeedsApproval]: 'Access to data pending',
    [VmAdminApprovalStatusEnum.Approved]: 'Access to Data Granted',
    [VmAdminApprovalStatusEnum.Automatic]: 'Has DUA Approval',
    [VmAdminApprovalStatusEnum.Disapproved]: 'Access to Data Denied',
    [VmAdminApprovalStatusEnum.NotApplicable]: null
};

// DEV-510: labels for data-access permissions (AccessToData)
const accessToDataLabels = {
    [ResearchTeamMemberAccessStatusEnum.Pending]: 'Access to Data Pending',
    [ResearchTeamMemberAccessStatusEnum.Granted]: 'Access to Data Granted',
    [ResearchTeamMemberAccessStatusEnum.Denied]: 'Access to Data Denied'
};

// DEV-516: labels for data-request-access permissions (AccessToDataRequest)
const accessToDataRequestLabels = {
    [ResearchTeamMemberAccessStatusEnum.Pending]: 'Access to Data Request Pending',
    [ResearchTeamMemberAccessStatusEnum.Granted]: 'Access to Data Request Granted',
    [ResearchTeamMemberAccessStatusEnum.Denied]: 'Access to Data Request Denied'
};

// DEV-516: account-state labels for the computed Status Details column.
const accountStatusLabels = {
    [ResearchTeamMemberAccountStatusEnum.NoAccount]: 'No Account',
    [ResearchTeamMemberAccountStatusEnum.Disabled]: 'Account Disabled',
    [ResearchTeamMemberAccountStatusEnum.Enabled]: 'Account Enabled'
};

const phaseLabels = {
    phaseTable: [
        { value: '', label: '' },
        { value: 'NA', label: 'N/A' },
        { value: 'EarlyPhase1', label: 'Early Phase 1' },
        { value: 'Phase1', label: 'Phase 1' },
        { value: 'Phase1Phase2', label: 'Phase 1/Phase 2' },
        { value: 'Phase2', label: 'Phase 2' },
        { value: 'Phase2a', label: 'Phase 2a' },
        { value: 'Phase2b', label: 'Phase 2b' },
        { value: 'Phase2Phase3', label: 'Phase 2/Phase 3' },
        { value: 'Phase3', label: 'Phase 3' },
        { value: 'Phase3a', label: 'Phase 3a' },
        { value: 'Phase3b', label: 'Phase 3b' },
        { value: 'Phase4', label: 'Phase 4' }
    ]
};

export const AdminApprovalConstant = {
    VmAdminApprovalLabels,
    menuVMAdminApprovalLabels,
    accessToDataLabels,
    accessToDataRequestLabels,
    accountStatusLabels,
    phaseLabels
};
